import React from 'react';
import TextWithTooltip from '../../../../../components/TextWithTooltip/TextWithTooltip';
import getName from '../../../../../helpers/getName';
import { getTooltipTitleForWorker } from '../../lib/utils';
import BlockWithExtraContent from '../../../../../components/BlockWithExtraContent/BlockWithExtraContent';
import { useMeasure } from '../../../../../hooks/useMeasure';

const WorkerCellContent = ({ worker, ...props }) => {
  const [ref, { width }] = useMeasure();

  return (
    <div
      ref={ref}
      {...props}
    >
      <TextWithTooltip
        parentWidth={width}
        mainTitle={getTooltipTitleForWorker(worker)}
        render={({ textRef, ...renderProps }) => (
          <BlockWithExtraContent
            {...renderProps}
            ref={textRef}
            main={getName(worker)}
            extra={worker?.specialityName || worker?.speciality}
          />
        )}
      />
    </div>
  );
};

export default WorkerCellContent;
